import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { resolveBokunPolicy } from "./bokun-policy";

export const getTourPolicy = createServerFn({method:"GET"})
 .inputValidator(z.object({id:z.string().regex(/^\d{1,12}$/),language:z.string().max(5),rateId:z.string().nullable().optional(),date:z.string().nullable().optional(),startTimeId:z.string().nullable().optional()}))
 .handler(async ({data})=>{
  const {assertPublicBokunId}=await import("./public-catalog-guard.server");
  await assertPublicBokunId(data.id);
  const {bokunGet}=await import("./bokun-core.server");
  // Bypass the shared stale-while-revalidate catalog cache: an API error is not a missing policy.
  const product=await bokunGet<Record<string,unknown>>(`/activity.json/${data.id}`,{lang:data.language.toUpperCase()},0);
  let departure: Record<string,unknown> | undefined;
  if(data.date){
   const slots=await bokunGet<Record<string,unknown>[]>(`/activity.json/${data.id}/availabilities`,{start:data.date,end:data.date,currency:"MXN"},0);
   departure=slots.find(s=>String(s.startTimeId ?? "")===String(data.startTimeId ?? ""));
   if(!departure) throw new Error("Departure unavailable");
  }
  return resolveBokunPolicy(product,{productId:data.id,language:data.language,rateId:data.rateId ?? (product.defaultRateId == null ? null : String(product.defaultRateId)),date:data.date,startTime:typeof departure?.startTime === "string" ? departure.startTime : null,departure});
 });